import React from 'react';
import GlassPill from '@/components/ui/GlassPill';
import { Globe } from 'lucide-react';
import { getCountryDisplayName } from '@/lib/countries';
import { getShortCategoryName } from '@/utils/research-category-utils';

interface ResearchCardHeaderProps {
  researchId: string;
  researchType: string;
  researchTypeConfig: any;
  locationDisplay: string | null;
}

const ResearchCardHeader: React.FC<ResearchCardHeaderProps> = ({
  researchId,
  researchType,
  researchTypeConfig,
  locationDisplay,
}) => {
  return (
    <div className="flex items-center justify-between mb-2 md:mb-4">
      <div className="flex items-center gap-2">
        <GlassPill 
          type={getShortCategoryName(researchType)} 
          variant={researchTypeConfig?.colorVariant || 'blue'}
          className="text-xs font-medium px-3 py-1"
        />
        
        {/* Country tag moved from footer to header */}
        {locationDisplay && (
          <GlassPill 
            type="" 
            variant="blue"
            className="text-xs font-medium px-3 py-1"
          >
            <Globe size={12} />
            <span>{getCountryDisplayName(locationDisplay)}</span>
          </GlassPill>
        )}
      </div>
    </div>
  );
};

export default ResearchCardHeader;
